let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fVKzA")).then(() => parcelRequire('1Hqud'));